<template>
    <tr>
        <td>
            {{item.id}}
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre de la subzona de recogida"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.name}}
            </span>
        </td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="deletePickupzone"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
        </td>
        
    </tr>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        suprazone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.item != null ? this.item.name : ''
            },
        }
    },
    async mounted() {
        
    },
    methods: {
        async editRow()  {
            this.edit = true
            
        },
        async saveChanges() {
            this.edit = false
            const data = {
                suprazone_id: this.suprazone.id,
                pickupzone_id: this.item.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('pickupzones/updatePickupzone', data)
            .then( response => {
                this.$notify({
                    group: "foo",
                    title: "Subzona de recogida editada",
                    text: "Se ha editado la información de la subzona de recogida",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "Fallo modificando",
                    text: "No se ha podido modificar",
                    type: "error",
                });
            })
        },
        async deletePickupzone() {
            const data = {
                pickupzone_id: this.item.id,
            }
            this.$store.dispatch('pickupzones/deletePickupzone', data)
            .then( response => {
                this.$store.dispatch('pickupzones/loadPickupzonesBySuprazone', this.suprazone.id)
                this.$notify({
                    group: "foo",
                    title: "La zona se ha eliminado",
                    text: "La zona " + this.item.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "La zona no se puede eliminar",
                    text: "La zona " + this.item.name + " no se puede eliminar ya que tiene objetos vinculados (subzonas de recogida o puntos geográficos)",
                    type: "error",
                });
            })
        }
    },
    computed: {
    }
    
}
</script>